import { useTranslation } from 'react-i18n-lite'

import { formatFileSize } from 'modules/shared/utils/formatFileSize'
import Player from 'modules/shared/WebcamStreamCapture/components/Player'
import ActivityValue from './ActivityValue'

interface ActivityDocumentVideoProps {
  values: string
}

const ActivityDocumentVideo = ({ values }: ActivityDocumentVideoProps) => {
  const { t } = useTranslation()

  const obj = JSON.parse(values)

  return (
    <>
      <ActivityValue
        label={t('activity-document-video.labels.des')}
        value={obj.des}
      />
      <ActivityValue
        label={t('activity-document-video.labels.uuid-video')}
        value={obj.uuid}
      />
      <ActivityValue
        label={t('activity-document-video.labels.status')}
        value={obj.uuid_status}
      />
      <div className='row'>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-video.labels.content-type')}
            value={obj.contentType}
          />
        </div>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-video.labels.size')}
            value={obj.size ? formatFileSize(Number(obj.size)) : ''}
          />
        </div>
      </div>
      <div className='w-100 d-flex justify-content-center align-items-center'>
        {obj?.file ? (
          <Player source={obj.file} type={obj.contentType || 'video/mp4'} />
        ) : (
          <div className='w-100 webcam-no-image rounded'>
            {t('activity-document-video.no-video')}
          </div>
        )}
      </div>
    </>
  )
}

export default ActivityDocumentVideo
